import React from 'react'
import MultiSelect from '../../components/MultiSelect'
import { Accommodation } from '../../../types'

interface StudentAccommodationsTabProps {
  selectedAccommodations: Accommodation[]
  handleAccommodationChange: (selectedIds: string[]) => void
}

const StudentAccommodationsTab: React.FC<StudentAccommodationsTabProps> = ({
  selectedAccommodations,
  handleAccommodationChange,
}) => {
  const getAvailableAccommodations = () => {
    return Object.values(Accommodation).map((accommodation) => ({
      _id: accommodation,
      name: accommodation,
    }))
  }

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Accommodations
        </label>
        <MultiSelect
          options={getAvailableAccommodations()}
          selectedValues={selectedAccommodations}
          onChange={handleAccommodationChange}
          placeholder="Select accommodations for this student..."
          className="w-full"
          fixed={true}
        />
        <p className="mt-1 text-xs text-gray-500">
          Select which accommodations apply to this student
        </p>
      </div>
    </div>
  )
}

export default StudentAccommodationsTab
